<template>
<div class="divider">
    <p class="contentLabel">Font</p>
    <select v-model="fontFamily" id="fontFamily">
    <option v-for="(font, key) in fontFamilyMapping" :key="key" :value="key" :style="{ fontFamily: font }">
        {{ key }}
    </option>
    </select>
</div>
</template>

<script>
export default {
    props: ['sharedData'],
    computed:{
    fontFamily: {
    get() {
      return this.sharedData?.data?.style?.fontFamily || 'DEFAULT';
    },
    set(value) {
      if (!this.sharedData.data.style) this.sharedData.data.style = {};
      this.sharedData.data.style.fontFamily = value;
    }},
    fontFamilyMapping() {
      return {
        BOOK_SANS: 'Optima, Candara, "Noto Sans", source-sans-pro, sans-serif',
        ORGANIC_SANS: 'Seravek, "Gill Sans Nova", Ubuntu, Calibri, "DejaVu Sans", source-sans-pro, sans-serif',
        GEOMETRIC_SANS: 'Avenir, "Avenir Next LT Pro", Montserrat, Corbel, "URW Gothic", source-sans-pro, sans-serif',
        HEAVY_SANS: 'Bahnschrift, "DIN Alternate", "Franklin Gothic Medium", "Nimbus Sans Narrow", sans-serif-condensed, sans-serif',
        ROUNDED_SANS: 'ui-rounded, "Hiragino Maru Gothic ProN", Quicksand, Comfortaa, Manjari, "Arial Rounded MT Bold", Calibri, source-sans-pro, sans-serif',
        MODERN_SERIF: 'Charter, "Bitstream Charter", "Sitka Text", Cambria, serif',
        BOOK_SERIF: '"Iowan Old Style", "Palatino Linotype", "URW Palladio L", P052, serif',
        MONOSPACE: '"Nimbus Mono PS", "Courier New", "Cutive Mono", monospace',
        MODERN_SANS: '"Helvetica Neue", "Arial Nova", "Nimbus Sans", Arial, sans-serif',
        SIMPLE: 'Arial',
        DEFAULT: 'inherit',
    };
  }
  },
    }

</script>

<style>
@import '../../../styles/addComponents.css';
</style>